import React, { useState } from 'react';
import BaseTableReport from 'components/atoms/base-table/report/report';
import { useTranslation } from 'react-i18next';
import { useSmsCampaignsAnswersData } from 'infrastructure/hooks/sms-campaigns/use-sms-campaigns-answers-data';
import { prepareDoctorName } from 'infrastructure/functions';

import { useColumns } from './columns';
import s from './styles.module.scss';
import AnswersDraggableModal from '../../answers/draggable-modal';

import type {
  ISmsCampaignAnswer,
  ISmsResponsesFilters,
} from 'infrastructure/interfaces';

interface IProps {
  filters: ISmsResponsesFilters;
  campaignGuid: string;
}

const SmsCampaignsAnswersTable: React.FC<IProps> = ({
  filters,
  campaignGuid,
}) => {
  const { t } = useTranslation();

  const { data, isLoading, pageSize } = useSmsCampaignsAnswersData({
    ...filters,
    campaignGuid,
  });
  const [campaign, setCampaign] = useState<ISmsCampaignAnswer | undefined>();

  const handleOpen = (c: ISmsCampaignAnswer) => {
    setCampaign(c);
  };
  const handleClose = () => {
    setCampaign(undefined);
  };

  const columns = useColumns({ onOpen: handleOpen });

  const handleChangePage = () => {};

  return (
    <div>
      <BaseTableReport
        rowKey="guid"
        headerTitle={t('labels.answers')}
        isLoading={isLoading}
        columns={columns as any}
        className={s.table}
        dataSource={data?.data}
        totalCount={data?.count}
        pagination={{
          current: filters.page,
          pageSize,
          total: data?.count,
          onChange: handleChangePage,
        }}
        showCount
        anchor
      />
      {campaign && campaign.outcomes && (
        <AnswersDraggableModal
          title={prepareDoctorName({
            firstName: campaign.firstName,
            lastName: campaign.lastName,
            title: campaign.title,
          })}
          subTitle={t('smsCampaign.dragModalSubtitle')}
          outcomes={campaign.outcomes}
          patient={{
            guid: campaign.guid,
            firstName: campaign.firstName,
            lastName: campaign.lastName,
            title: campaign.title,
            birthDate: campaign.birthDate,
            email: campaign.email,
            outcomesQuestionLanguage: campaign.outcomesQuestionLanguage,
            outcomesQuestionGroup: campaign.outcomesQuestionGroup,
            ccmStatus: campaign.ccmStatus,
            phone: '',
            timezone: '',
          }}
          onClose={handleClose}
          opened
          campaignGuid={campaignGuid}
        />
      )}
    </div>
  );
};

export default SmsCampaignsAnswersTable;
